'use client'

import type { ColorBadgeType } from '@syconium/little-miss-figgy'

import { useTranslation } from '../_providers/TranslationProvider.client'

export function useColorBadge() {
  const {
    pages: {
      product: { colorBadges },
    },
  } = useTranslation()

  const isSupportedBadge = (badge: string): badge is keyof typeof colorBadges =>
    badge in colorBadges

  return (
    badge: string | null | undefined,
    badgeExpiration?: string | null
  ): ColorBadgeType | null => {
    const badgeKey = badge?.toLowerCase()
    if (!badgeKey || !isSupportedBadge(badgeKey)) return null

    return {
      text: colorBadges[badgeKey],
      expiration: badgeExpiration ? new Date(badgeExpiration) : null,
    }
  }
}
